import L from 'leaflet';

export function bindLegendEvents({
    map,
    element,
    polylineRef,
    defaultWeight,
    hoverWeight,
    onFocus
}) {

    if (!element) {
        return;
    }

    const focusPolyline = () => {

        onFocus?.();

        const latlngs = polylineRef.current?.getLatLngs?.();

        if (!latlngs?.length) {
            return;
        }

        map.fitBounds(
            L.latLngBounds(latlngs),
            {
                padding: [30, 30],
                animate: false 
            }
        );

    };

    element.addEventListener('click', focusPolyline);

    element.addEventListener(
        'mouseenter',
        () =>
            polylineRef.current?.setStyle({
                weight: hoverWeight,
            })
    );

    element.addEventListener(
        'mouseleave',
        () =>
            polylineRef.current?.setStyle({
                weight: defaultWeight,
            })
    );

}